import { MetaConversation } from 'lib-shared-legacy-types';

export const getConversationTitle = (metaConversation: MetaConversation) => {
  const { requester } = metaConversation;
  const {
    id: csid,
    attributes,
    is_abandoned: isAbandoned,
  } = metaConversation.conversation;

  const requesterInfo = requester
    ? requester.name ||
      requester.email ||
      requester.phone_number ||
      (requester.anonymized_at ? 'Anonymized user' : '')
    : `#${csid}`;

  const subject = attributes?.subject || '';

  return {
    requester: `${isAbandoned ? 'Abandoned: ' : ''}${requesterInfo}`,
    subject,
  };
};
